export const NUMBER_OF_ROWS_PER_PAGE = 100;
export const GRID_PAGE_SIZES = [20, 50, 100, 500];
export const AUTH_TOKEN = "IDToken";
export const IS_CIVIL_DEFENSE = "IsCivilDefense";
export const LANGuAGE_COOKIE = "language";
export const ALLOWED_FILES_EXTENSION = ".pdf,.jpg,.jpeg";
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const MAX_TEXT_FIELD_SIZE = 255;
export const LG_TEXT_FIELD_SIZE = 100;
export const MD_TEXT_FIELD_SIZE = 50;
export const DELAY_TIME = 1000;
export const MOBILE_SIZE = 768;
export const PHONE_REGEX = /^(?:50|52|53|54|55|56|57|58)\d{7}$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const LATITUDE_REGEX =
  /^(22\.5|22\.[5-9]\d{0,3}|2[3-5](\.\d{1,4})?|26(\.([0-4]\d{0,3}|50{0,3}))?|26)$/;
export const LONGITUDE_REGEX =
  /^(51\.5|51\.50|51\.500|51\.5000|51\.[5-9]\d{0,3}|5[2-5](\.\d{1,4})?|56(\.([0-4]\d{0,3}|50{0,3}))?|56)$/;
export const SECRET_KEY = "bR*XqynvuQV_DzEb";
export const EMIRATEID_REGEX =
  /^(?!000-0000-0000000-0)\d{3}-\d{4}-\d{7}-\d{1}$/;
export const LOCATION_LONGITUDE_REGEX =
  /^(-?(180(\.\d{1,4})|1[0-7][0-9](\.\d{1,4})|[1-9]?[0-9](\.\d{1,4})))$/;

export const LOCATION_LATITUDE_REGEX =
  /^(-?(90(\.\d{1,4})|[1-8]?[0-9](\.\d{1,4})))$/;

export const OTP_LENGTH = 5;

export const devLocationOrigin = "http://localhost:3000";

export const MaintenanceRequestsOrderedColumns = [
  "caseID",
  "buildingName",
  "status",
  "typeOfApproval",
  "sLABreached",
  "creationDate",
  "systemName",
  "systemSubtype",
  "faultLocation",
  "faultDescription",
  "bldgContactPerson",
  "phone",
  "latitude",
  "longitude",
  "territory",
  "propertyTradeLicense",
  "pRPNumber"
];

export const PreventiveAppointmentsOrderedColumns = [
  "appointmentDate",
  "appointmentType",
  "status",
  "typeOfApproval",
  "propertyID",
  "buildingName",
  "latitude",
  "longitude",
  "territory",
  "completionDate",
];
export const CDPreventiveAppointmentsOrderedColumns = [
  "appointmentDate",
  "appointmentType",
  "companyName",
  "status",
  "typeOfApproval",
  "propertyID",
  "buildingName",
  "latitude",
  "longitude",
  "territory",
];

export const AssignedBuildingsOrderedColumns = [
  "propertyID",
  "buildingName",
  "activeContracts",
];

export const ATECasesOrderedColumns = [
  "caseId",
  "systemName",
  "errorCodeDescription",
  "creationDate",
  "sLABreached",
  "status",
  "typeOfApproval",
  "propertyID",
  "buildingName",
  "emirate",
  "city",
  "territory",
  "latitude",
  "longitude",
  "contractReferenceNumber",
  "resolutionDate",
  "technicianName",
   "propertyTradeLicense",
  "pRPNumber",
];

export const CDATECasesOrderedColumns = [
  "caseId",
  "systemName",
  "errorCodeDescription",
  "companyName",
  "creationDate",
  "sLABreached",
  "status",
  "typeOfApproval",
  "propertyID",
  "buildingName",
  "emirate",
  "city",
  "territory",
  "latitude",
  "longitude",
  "contractReferenceNumber",
  "resolutionDate",
  "technicianName",
   "propertyTradeLicense",
  "pRPNumber"
];
export const CDBreachedATECasesOrderedColumns = [
  "caseId",
  "systemName",
  "errorCodeDescription",
  "companyName",
  "creationDate",
  "sLABreached",
  "status",
  "typeOfApproval",
  "propertyID",
  "buildingName",
  "emirate",
  "city",
  "territory",
  "latitude",
  "longitude",
  "contractReferenceNumber",
  "technicianName",
];
export const BMCWithRatingsColumns = [
  "companyName",
  "rating",
  "paymentStatus",
  "numberOfBuildings",
  "contactPersonName",
  "phoneNumber",
];

export const chartOptions = {
  responsive: true,
  maintainAspectRatio: true,

  cutout: "80%",
  plugins: {
    tooltip: {
      enabled: false,
    },
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
  },
  rotation: -120, // Start point
  circumference: 240,
};

export const INVOICE_PAYMENT_OPTIONS = [
  {
    englishName: "Not Paid",
    arabicName: "غير مدفوعة",
    id: "0",
  },
  {
    englishName: "Pending Payment",
    arabicName: "بإنتظار الدفع",
    id: "1",
  },
  {
    englishName: "Paid",
    arabicName: "مدفوعة",
    id: "2",
  },
  {
    englishName: "Refunded",
    arabicName: "مستردة",
    id: "3",
  },
];
export const CONSOLIDATED_PAYMENT_OPTIONS = [
  {
    englishName: "Not Paid",
    arabicName: "غير مدفوعة",
    id: "1",
  },
  {
    englishName: "Pending Payment",
    arabicName: "بإنتظار الدفع",
    id: "2",
  },
  {
    englishName: "Paid",
    arabicName: "مدفوعة",
    id: "3",
  },
];

export const SortOrderDefault = 1; // Ascending
